import axiosClient from './axiosClient';
import { IParamsGetMasterData, IResponseGetMasterData } from '~/utils/interface/master';
import { IApiBaseResponse } from '~/utils/interface/common';

const masterApi = {
  getMasterData(params: IParamsGetMasterData) {
    const url = `/api/admin/master-data`;
    return axiosClient.get<IApiBaseResponse<IResponseGetMasterData>>(url, { params });
  },
};

export default masterApi;
